(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DateExtended", [], factory);
	else if(typeof exports === 'object')
		exports["DateExtended"] = factory();
	else
		root["DateExtended"] = factory();
})(window, function() {
return 